import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iban'
})
export class IbanPipe implements PipeTransform {
  transform(value: any): string {
    if (value) {
      value = value.toString();
      let base = value.split('').filter((x: any) => x != ' ');
      let bArr = [];
      for (let i = 0; i < base.length; i += 4) {
        let temp = '';
        if (base[i]) {
          temp += base[i];
        }
        if (base[i + 1]) {
          temp += base[i + 1];
        }
        if (base[i + 2]) {
          temp += base[i + 2];
        }
        if (base[i + 3]) {
          temp += base[i + 3];
        }
        bArr.push(temp);
      }
      return bArr.join(' ');
    }
    return '';
  }
}
